import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../services/user.service';
import {UserStatusService} from '../user-status/user-status.service';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-user-edit',
    templateUrl: './user-add.component.html',
    styleUrls: ['./user-add.component.scss'],
    providers: [
        UserStatusService
    ]
})
export class UserAddComponent implements OnInit {
    public model:  any = {};
    public errors: any = {};
    public activeStatus: number;
    public loading = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService,
        private title: Title
    ) {
        this.title.setTitle('Admin - Users');
    }

    ngOnInit(): void {
        this.activeStatus = UserStatusService.STATUS_ACTIVE;
        this.model.status = this.activeStatus;
        this.model.role   = '';
    }

    onCancel(): void {
        this.router.navigate(['/user']);
    }

    onChangeUserStatus(value: number){
        this.model.status = value;
    }

    onChangeUserRole(value: string) {
        this.model.role = value;
    }

    onAdd(): void {
        this.loading = true;
        this.userService.save(this.model, true).subscribe( result => {

            this.loading = false;
            if (result.errors) {
                this.errors = result.errors;
            } else {
                this.onCancel();
            }
        });
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/user/user-add/user-add.component.ts